export default __webpack_public_path__ + "static/media/reports.48797980.svg";